import React from 'react';
import PropTypes from 'prop-types';

function TableComponents({
  literals,
  rows,
  component,
  componentColumns,
  componentProps,
  actualPage,
  pageSize,
  fetchError,
  emptyImage,
  emptyMessage,
  width,
  WarningImage,
  isLoading,
}) {
  const renderLoading = () => {
    const numRows = rows !== null && rows.total > 0 && rows.total < pageSize ? rows.total : pageSize;
    if (!numRows) return null;

    return Array.from(new Array(Math.max(numRows, 1))).map((e, i) => React.createElement(component, {
      loading: true,
      key: i.toString(),
      id: i.toString(),
      ...componentProps,
    }));
  };

  const renderRows = () => {
    if (rows?.items?.length > 0) {
      return rows.items.map((row, i) => {
        let rowProps = {
          key: row.id,
          ...row,
          ...componentProps,
          _tableRow: { index: i, page: actualPage },
        };
        if (componentProps) {
          rowProps = Object.assign(rowProps, componentProps);
        }
        return React.createElement(component, rowProps);
      });
    }

    if (fetchError) {
      return (
        <div className='panel-empty-message'>
          <img src={WarningImage} alt={emptyMessage ?? literals.noResults} />
          <p>{fetchError}</p>
        </div>
      );
    }

    return (
      <div className='panel-empty-message'>
        {
          emptyImage && (
            <img src={emptyImage} alt={emptyMessage ?? literals.noResults} />
          )
        }
        <p>{emptyMessage ?? literals.noResults}</p>
      </div>
    );
  };

  return (
    <div
      className={`${componentColumns ? 'grid' : ''}`}
      style={{
        gridTemplateColumns: `repeat(${isLoading || rows?.items?.length > 0
          ? componentColumns[width] : 1}, 1fr)`,
      }}
    >
      {!isLoading ? renderRows() : renderLoading()}
    </div>
  );
}

TableComponents.propTypes = {
  rows: PropTypes.object,
  component: PropTypes.func,
  componentProps: PropTypes.object,
  actualPage: PropTypes.number,
  fetchError: PropTypes.string,
  emptyImage: PropTypes.string,
  emptyMessage: PropTypes.string,
  componentColumns: PropTypes.array,
  width: PropTypes.number,
  literals: PropTypes.object,
  WarningImage: PropTypes.string,
  isLoading: PropTypes.bool,
  pageSize: PropTypes.number,
};
export default TableComponents;
